import { CardsScheme } from '../../enums/scheme.enum';

export interface ICardHolderAccount {
  cardExpiryDate?: string;
  acctNumber?: string;
  schemeID?: CardsScheme;
}

export class CardHolderAccount implements ICardHolderAccount {
  constructor(
    cardExpiryDate?: string,
    acctNumber?: string,
    schemeID?: CardsScheme
  ) {}
}
